module.exports = __webpack_public_path__ + "static/img/empty-icon.5221d82.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/empty-icon.png
// module id = cdxI
// module chunks = 1